import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';

import { LocalStorageProperties } from '../../../features/shared/enums/local-storage-properties.enum';
import localStorageService from '../../../features/shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../../features/shared/utils/create-path-params/create-path-params.util';
import { WithMandantThunkModel } from './models/with-mandant-thunk.model';

export const withMandant = <ThunkArg, Returned>(
  endpoint: string,
  typePrefix: string,
  func: (args: WithMandantThunkModel<ThunkArg>) => Returned | Promise<Returned>
): AsyncThunk<Returned, ThunkArg, Record<string, unknown>> => {
  const mandantId = localStorageService.get(
    LocalStorageProperties.SELECTED_MANDANT
  ) as string | null;

  const urlWithMandant = createPathParams<'mandantId'>(endpoint, {
    ...(mandantId !== null && { mandantId: parseInt(mandantId, 10) }),
  });

  return createAsyncThunk<Returned, ThunkArg, Record<string, unknown>>(
    typePrefix,
    async (args: ThunkArg, { rejectWithValue }) => {
      try {
        return await func({ args, endpoint: urlWithMandant });
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  );
};
